import { AccountContainer } from "src/components/account/AccountContainer";
import { Login } from "src/components/account/login";
import { urls } from "src/constants";

export default function DonorLoginPage() {
  return (
    <AccountContainer>
      <Login defaultNextPath={urls.donor.pledges} showPasswordReset />
    </AccountContainer>
  );
}
